import {
  SET_CONTRACTS_VIEW,
  SET_CONTRACTS_LIST,
  POPUP_SET_FINGER_SIGNATURE_POPUP_STATE,
  UPDATE_CONTRACTS_LIST, SET_CONTRACT_UPLOADED
} from "../../constants/actionTypes";

export const CONTRACTS_VIEWS = {
  contracts: "contracts",
  upload: "upload",
  success: "success",
}

const initialState = {
  contractsView: CONTRACTS_VIEWS.contracts,
  contractsList: [],
};

export default function (state = initialState, action) {
  switch (action.type) {
    case SET_CONTRACTS_LIST:
    case SET_CONTRACTS_VIEW:
    case UPDATE_CONTRACTS_LIST:
      return Object.assign({}, state, {...action.payload});
    case POPUP_SET_FINGER_SIGNATURE_POPUP_STATE: // reset view
      return Object.assign({}, state, {contractsView: CONTRACTS_VIEWS.contracts});
  }

  return state;
}
